import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { steps } from '../../data/content';
const optimizeList = ['What to monitor', 'When to follow up', 'When to adjust therapy', 'When to switch treatment', 'When to discontinue therapy'];
export function Steps() {
  return <Section tone="cream" data-id="element-253" data-mp="1lvndb9ld205d">
      <SectionTitle eyebrow="The system" data-id="element-254" data-mp="1lvwtk5glssxv">
        Here's How the Blueprint Works
      </SectionTitle>

      <ol className="mt-8 space-y-4" data-id="element-255" data-mp="1gwah3y8lngq4">
        {steps.map((step, index) => <li key={step.step} className="relative overflow-hidden rounded-3xl border border-navy/10 bg-white p-5 sm:p-6" data-id="element-256" data-mp="1c5kdapftnlxj" data-mpi={index}>
            <span className="absolute -right-3 -top-4 font-display text-[5rem] font-bold leading-none text-navy/[0.05]" data-id="element-257" data-mp="176h7v3vxjdp1">
              {index + 1}
            </span>
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-258" data-mp="1zudbksjx25vb">
              {step.step}
            </p>
            <h3 className="relative mt-2 font-display text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-259" data-mp="1yokd6qa3x1qa">
              {step.title}
            </h3>
            <p className="relative mt-2.5 text-[14.5px] leading-relaxed text-navy/70" data-id="element-260" data-mp="1oyr5w1gzz8ru">
              {step.body}
            </p>

            {index === 3 ? <ul className="relative mt-4 grid gap-2" data-id="element-261" data-mp="1tupplbrds2lx">
                {optimizeList.map(item => <li key={item} className="flex items-center gap-2 text-[14px] font-medium text-navy/80" data-id="element-262" data-mp="1jyv0bxsnj9a6">
                    <CheckIcon className="h-4 w-4 shrink-0 text-gold-dark" data-id="element-263" data-mp="160odrdt5kvpt" />
                    {item}
                  </li>)}
              </ul> : null}

            <div className="relative mt-4 flex flex-wrap gap-2" data-id="element-264" data-mp="30eft8ty5y9t6">
              {step.highlights.map(highlight => <span key={highlight} className="rounded-full bg-navy px-3 py-1.5 text-[12px] font-semibold text-white" data-id="element-265" data-mp="35bfxr0fd74i6">
                  {highlight}
                </span>)}
            </div>
          </li>)}
      </ol>

      <CTAButton className="mt-8" variant="navy" label="Start following these 4 steps today" subline="Instant access • Lifetime updates" data-id="element-266" data-mp="2tx4j1osxk8no" />
    </Section>;
}